'use client'

import * as React from 'react'
import { createIcon } from '../utils'

const AttachmentIcon = createIcon({
    displayName: 'AttachmentIcon',
    viewBox: '0 0 16 16',
    fill: 'none',
    path: (
        <path
            d="M14.102 7.466l-6.01 6.01a3.5 3.5 0 01-4.95-4.95l6.01-6.01a2.333 2.333 0 113.3 3.3l-5.775 5.775a1.167 1.167 0 01-1.65-1.65l5.068-5.068"
            stroke="currentColor"
            strokeWidth={1.2}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    ),
})

export default AttachmentIcon
